function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1_Article",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-176.000000, -354.000000)",
  fill: "#2E2E2E",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "article",
  transform: "translate(176.000000, 354.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,0 L15,0 C15.5522847,-1.01453063e-16 16,0.44771525 16,1 L16,19 C16,19.5522847 15.5522847,20 15,20 L1,20 C0.44771525,20 0,19.5522847 0,19 L0,1 C0,0.44771525 0.44771525,1.01453063e-16 1,0 Z M2,2 L2,18 L14,18 L14,2 L2,2 Z M4,5 L8,5 L8,7 L4,7 L4,5 Z M4,13 L12,13 L12,15 L4,15 L4,13 Z M4,9 L12,9 L12,11 L4,11 L4,9 Z",
  id: "Shape"
}))));

var SvgArticle = function SvgArticle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArticle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/article.f3b11611.svg";
export { ForwardRef as ReactComponent };